<template>
  <div>
    <h1 class="page-title">My profile</h1>
    <div class="profile-and-event-container">
      <ProfileForm />
      <v-divider></v-divider>
      <ProfileExtraInfo />
    </div>
  </div>
</template>

<script>
import ProfileForm from "@/components/molecules/ProfileForm";
import ProfileExtraInfo from "@/components/molecules/ProfileExtraInfo";

export default {
  components: {
    ProfileForm,
    ProfileExtraInfo,
  },
};
</script>